import { render } from "./AdminTopComponent.vue?vue&type=template&id=37c3c40f&scoped=true&ts=true"
import script from "./AdminTopComponent.vue?vue&type=script&lang=ts"
export * from "./AdminTopComponent.vue?vue&type=script&lang=ts"

import "./AdminTopComponent.vue?vue&type=style&index=0&id=37c3c40f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c3c40f"]])

export default __exports__